export default "__VITE_PUBLIC_ASSET__aead80d0__"